import React from 'react';
import { Link } from 'react-router-dom';
import { Footer, Header } from '../index';
import dc from '../../documents/docs.pdf' ;
import  './Documents.css';
function Documents() {
  return (
    <>
        <Header />
        <div className='bgDoculents'>  </div>
        <div className='ligne'></div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-150px', marginBottom: '100px' }}>
          <h1 style={{fontFamily:'fantasy'}}className="container-fluid text-white text-center "id='h1DOC'>Manuelle des procédures Administratifs</h1>
          <p ><Link className='linkLicences' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkLicences'
            to="/Documents"> Vie étudiante </Link>  <span>{'>'}</span> <Link className='linkLicences'
            to="/Documents">Manuelle des procédures Administratifs</Link> </p></div>
     
        

        <div  style={{ width: '100%', height: '100%',marginBottom:'5%', display: 'flex', justifyContent: 'center', alignItems: 'center' , position:'relative'}}>
        <embed src={dc} type="application/pdf" width="900px" height="900px" />
      </div> 
      <Footer />
    </>
  )
}

export default Documents